<script>
import Service from '../../services/common';
import Dialog from 'primevue/dialog';

const vesselApi = 'masterdata/vessel';

export default{
    components: {Dialog},
    props: ['item'],
    data(){
        return {
            imoCode: null,
            visible: false
        }
        
    },
    mounted(){

    },
    methods: {
        getOrigin(){
            return location.origin;
        },
        loadVessel(){
            Service.loadGenericItem(vesselApi, this.item.vesselId, response => {
                if(response.success){
                    this.imoCode = response.data.imoNumber;
                    this.visible = true;
                }
            });
        }
    }
  }

</script>


<template>
    <main>
        <Dialog :header="$t('vessel.fk')" v-model:visible="visible" :style="{width: '75vw'}" :modal="true">
            <div class="container">
                <iframe
                    :src="getOrigin() + '/map.html?imoCode=' + imoCode"
                    width="100%"
                    height="600" 
                    frameborder="0" > 
                </iframe>
            </div>
        </Dialog>
    </main>

</template>